module.exports = __webpack_public_path__ + "media/images/main-bg-1024-9feafad686303cce69e7c64c7381ff39.png";